class AvDeviceSettingsService {
    constructor(storageService, config) {
        this.storageService = storageService;
        this.config = config;
    }

    setUsingAudioIn(deviceId) {
        this.storageService.set('audio-device', deviceId);
    }

    getUsingAudioIn() {
        return this.storageService.get('audio-device');
    }

    setUsingAudioOut(deviceId) {
        this.storageService.set('audio-output-device', deviceId);
    }

    getUsingAudioOut() {
        return this.storageService.get('audio-output-device');
    }

    setUsingVideo(deviceId) {
        this.storageService.set('video-device', deviceId);
    }

    getUsingVideo() {
        return this.storageService.get('video-device');
    }

    setExplicitlyChosenAudioIn(deviceId, deviceLabel) {
        this.setUsingAudioIn(deviceId);
        this.setExplicitlyChosenDevicesList('explicitly-chosen-audio-input-device', deviceId, deviceLabel);
    }

    setExplicitlyChosenAudioOut(deviceId, deviceLabel) {
        this.setUsingAudioOut(deviceId);
        this.setExplicitlyChosenDevicesList('explicitly-chosen-audio-output-device', deviceId, deviceLabel);
    }

    setExplicitlyChosenVideo(deviceId, deviceLabel) {
        this.setUsingVideo(deviceId);
        this.setExplicitlyChosenDevicesList('explicitly-chosen-video-input-device', deviceId, deviceLabel);
    }

    setExplicitlyChosenDevicesList(explicitlyChosenKey, deviceId, deviceLabel) {
        const storageListKey = explicitlyChosenKey + '-list';

        this.storageService.set(explicitlyChosenKey, deviceId);

        const deviceListRaw = this.storageService.get(storageListKey);
        const deviceArray = deviceListRaw && deviceListRaw.length > 0 ? JSON.parse(deviceListRaw) : [];
        deviceArray.unshift(deviceLabel);
        // Should add new item to 1st position and remove last if count > config.maxCountExplicitlyChosenDeviceHistory
        if (deviceArray.findLastIndex(e => e === deviceLabel) > 0) {
            deviceArray.splice(
                deviceArray.findLastIndex(e => e === deviceLabel),
                1
            );
        }

        if (deviceArray.length > this.config.maxCountExplicitlyChosenDeviceHistory) {
            deviceArray.pop();
        }

        this.storageService.set(storageListKey, JSON.stringify(deviceArray));
    }

    getExplicitlyChosenAudioIn(devicesList) {
        return this.getExplicitlyChosenDevice('explicitly-chosen-audio-input-device', devicesList);
    }

    getExplicitlyChosenAudioOut(devicesList) {
        return this.getExplicitlyChosenDevice('explicitly-chosen-audio-output-device', devicesList);
    }

    getExplicitlyChosenVideo(devicesList) {
        return this.getExplicitlyChosenDevice('explicitly-chosen-video-input-device', devicesList);
    }

    getExplicitlyChosenDevice(explicitlyKey, devicesList) {
        const deviceId = this.storageService.get(explicitlyKey);
        const device = deviceId ? devicesList.filter(d => d.deviceId === deviceId)[0] : null;

        // if previously user has explicitly chosen system device then return it
        if (device && (deviceId === 'default' || deviceId === 'communications')) {
            return device;
        }

        const result = this.getFirstDeviceFromExplicitList(explicitlyKey, devicesList);
        if (result) {
            return result;
        }

        return device ?? null;
    }

    getFirstDeviceFromExplicitList(key, devicesList) {
        const device = this.getFirstDeviceExistingInLocalStorage(`${key}-list`, devicesList);
        if (device) {
            this.storageService.set(key, device.deviceId);
        }

        return device;
    }

    getFirstDeviceExistingInLocalStorage(key, devicesList) {
        const storageValue = this.storageService.get(key);
        if (!storageValue || storageValue.length === 0) {
            return null;
        }

        const devicesInStore = JSON.parse(storageValue);
        if (!devicesInStore || devicesInStore.length === 0) {
            return null;
        }

        const devicesInExplicitlyList = devicesInStore.filter(e => devicesList.some(d => d.originalLabel === e));
        if (devicesInExplicitlyList.length === 0) {
            return null;
        }

        return devicesList.filter(e => e.originalLabel === devicesInExplicitlyList[0])[0];
    }
}

firebird.factory('avDeviceSettingsService', [
    'storageService',
    'config',
    (...deps) => new AvDeviceSettingsService(...deps)
]);
